import SageButton from "kit/SageButton";
import React from "react";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import createAnimationSelectedAnimationTypeSelector from "selectors/createAnimationSelectedAnimationType";
import AnimationSection from "./AnimationSection";
import styles from "./AnimationTypeSelectorSection.module.scss";
import YouTube from "react-youtube";

const AnimationTypeSelectorSection: React.FC = () => {
    const dispatch = useDispatch();

    const onFormSubmit = React.useCallback(
        (e: React.FormEvent<HTMLFormElement>) => {
            e.preventDefault();
            dispatch({
                type: "com.sage.actions.createAnimation.ISetTab",
                tab: 1,
            } as sage.actions.createAnimation.ISetTab);
        },
        [dispatch]
    );

    const onFormChange = React.useCallback(
        (e) => {
            dispatch({
                type: "com.sage.actions.createAnimation.ISetAnimationType",
                animationType: e.target.value,
            } as sage.actions.createAnimation.ISetAnimationType);
        },
        [dispatch]
    );

    const animationType = useSelector(
        createAnimationSelectedAnimationTypeSelector
    );

    return (
        <AnimationSection
            title="Select Animation Type"
            description="Rend A Hand offers various animation types to be selected from. Select the type of animation that you would like from the list below. In the next step, you will upload a video that uses this animation type."
        >
            <Form onChange={onFormChange} onSubmit={onFormSubmit}>
                <Form.Check
                    checked={animationType === "LEFT_HAND"}
                    value="LEFT_HAND"
                    type="radio"
                    label="Left Hand"
                />
                <Form.Check
                    checked={animationType === "RIGHT_HAND"}
                    value="RIGHT_HAND"
                    type="radio"
                    label="Right Hand"
                />
                <Form.Check
                    type="radio"
                    label="Both Hands (Coming Soon)"
                    disabled={true}
                />
                <Form.Check
                    type="radio"
                    label="Facial Expressions (Coming Soon)"
                    disabled={true}
                />
                <SageButton
                    disabled={!animationType}
                    className={styles.submitButton}
                    type="submit"
                    text="Next"
                />
            </Form>
            <hr />
            <h3>Want to see how it work?</h3>
            <p>
                Watch our example video to see all the steps in needed to create
                an animation.
            </p>
            <YouTube videoId={"mr37k2-4zuk"} />
        </AnimationSection>
    );
};

export default AnimationTypeSelectorSection;
